import React from "react";
import { Form, Input, Select } from "antd";
import { FormConfig } from "../config/GlobalConfig";

const FormItem = Form.Item;
const { Option } = Select;

const ReferenciaSelectFormItem = props => {
  return (
    <FormItem { ...props }>
      <Select showSearch filterOption={ FormConfig.DefaultSelectFilter }>
        { props.tabla.map(item => {
          let value = item.Codigo ? item.Codigo
            : item.CIIU ? item.CIIU 
            : item.ciuo88 ? item.ciuo88 
            : item.ID ? item.ID
            : item.Id ? item.Id
            : '';
          let desc = item.Descripcion ? item.Descripcion
            : item.DESCRIPCION ? item.DESCRIPCION 
            : item.descripcion ? item.descripcion 
            : item.NOMBRE ? item.NOMBRE
            : item.Nombre ? item.Nombre
            : '';
          return <Option key={ value } value={ value }>{ `${value} - ${desc}` }</Option>
        }) }
      </Select>
    </FormItem>
  );
}

export default ReferenciaSelectFormItem;